import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

export interface VersionInfo {
  environment: string;
  version: {
    semantic: string;
    platform: string;
    commit: string;
    dockerTag: string;
  };
  buildDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  // =============================================================================
  // Private Properties
  // =============================================================================

  private readonly buildDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format

  // =============================================================================
  // Public Methods
  // =============================================================================

  getVersionInfo(): VersionInfo {
    const envVer = environment.version || {
      semantic: '0.0.0',
      platform: '0.0.0',
      commit: 'Unknown',
      dockerTag: 'N/A',
    };
    return {
      environment: environment.environment || 'local',
      version: {
        semantic: envVer.semantic || '0.0.0',
        platform: envVer.platform || '0.0.0',
        commit: envVer.commit || 'Unknown',
        dockerTag: envVer.dockerTag || 'N/A',
      },
      buildDate: this.buildDate,
    };
  }

  getVersion(): string {
    return environment.version?.semantic || '0.0.0';
  }

  getFullVersionString(): string {
    const info = this.getVersionInfo();
    return `v${info.version.semantic} (${info.environment})`;
  }

  getBuildInfo(): string {
    const info = this.getVersionInfo();
    return `Built on ${info.buildDate}`;
  }
}
